import React from "react";

const EmailIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_122_1318"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_122_1318)">
        <path
          d="M3.33268 16.6663C2.87435 16.6663 2.48199 16.5031 2.1556 16.1768C1.82921 15.8504 1.66602 15.458 1.66602 14.9997V4.99967C1.66602 4.54134 1.82921 4.14898 2.1556 3.82259C2.48199 3.4962 2.87435 3.33301 3.33268 3.33301H16.666C17.1243 3.33301 17.5167 3.4962 17.8431 3.82259C18.1695 4.14898 18.3327 4.54134 18.3327 4.99967V14.9997C18.3327 15.458 18.1695 15.8504 17.8431 16.1768C17.5167 16.5031 17.1243 16.6663 16.666 16.6663H3.33268ZM16.666 6.66634L10.4368 10.5622C10.3674 10.6038 10.2945 10.6351 10.2181 10.6559C10.1417 10.6768 10.0688 10.6872 9.99935 10.6872C9.9299 10.6872 9.85699 10.6768 9.7806 10.6559C9.70421 10.6351 9.63129 10.6038 9.56185 10.5622L3.33268 6.66634V14.9997H16.666V6.66634ZM9.99935 9.16634L16.666 4.99967H3.33268L9.99935 9.16634ZM3.33268 6.87467V5.64551V5.66634V5.65592V6.87467Z"
          fill="#505050"
        />
      </g>
    </svg>
  );
};

export default EmailIcon;
